/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  SvgIcon,
  FileViewer,
  CenteredContainerDisplay,
  Button,
  Email
} from '../'

export default class RequestFileViewer extends React.Component {
  static propTypes = {
    files: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      asset: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })).isRequired
  }

  state = { displayEmail: null }

  render() {
    return (
      <div>
        {this.state.displayEmail
          ? <DisplayEmail
              email={this.state.displayEmail}
              onClick={() => this.setState({ displayEmail: null })}
            />
          : this.props.files.length > 0
            ? <FileViewer
                files={this.props.files}
                inline={true}
                preview={true}
                showMetaData={true}
                displayEmail={email => this.setState({ displayEmail: email })}
              />
            : <React.Fragment>
                <div></div>
                <CenteredContainerDisplay
                  content={
                    <div className='u-font-size-larger slds-text-color_inverse'>
                      <SvgIcon
                        variant='utility'
                        symbol='info'
                        colour='inverse'
                        size='small'
                        className='slds-m-right_small'
                      />
                      No files associated with this request.
                    </div>
                  }
                  yAdjustPercentage={-20}
                />
              </React.Fragment>
        }
      </div>
    )
  }
}

const DisplayEmail = ({ email, onClick }) => (
  <React.Fragment>
    <div className='slds-m-top_small slds-m-right_large slds-float_right' style={{ position: 'relative' }}>
      <Button type='brand' onClick={onClick}>
        Close email
      </Button>
    </div>
    <Email id={email} className='slds-p-around_medium slds-m-around_medium' />
  </React.Fragment>
)



// WEBPACK FOOTER //
// ./src/components/request-file-viewer/index.js